module.exports = "/img/_/_/_/assets/images/avatar/full_left/male//warrior.jpg?993a67c7efde667dd442c37a7b8eb005";